import { render, staticRenderFns } from "./Capacity.vue?vue&type=template&id=afc93b1c&scoped=true&lang=pug&"
import script from "./Capacity.vue?vue&type=script&lang=ts&"
export * from "./Capacity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc93b1c",
  null
  
)

export default component.exports